import { Card, CardTitle } from '@reveni-io/reveni-ui'

import MostReturnedContent from './MostReturnedContent/MostReturnedContent'
import * as Styles from './styles'

const MostReturnedCard = ({
  title,
  Icon,
  loading,
  item,
  percentage,
  count,
  countText,
  percentageText,
  breadcrumbs,
  sales,
  salesOrdersDataActivated,
}) => {
  return (
    <Card showBorder={false}>
      <CardTitle>
        <Styles.Title>
          {Icon && <Icon size={24} weight="light" />} {title}
        </Styles.Title>
      </CardTitle>
      <MostReturnedContent
        loading={loading}
        item={item}
        breadcrumbs={breadcrumbs}
        count={count}
        percentage={percentage}
        countText={countText}
        percentageText={percentageText}
        sales={sales}
        salesOrdersDataActivated={salesOrdersDataActivated}
      />
    </Card>
  )
}

export default MostReturnedCard
